import { canUseDOM } from "./dom"

export const getSortTermLocalStorage = (key: string) => {
  if (!canUseDOM()) return null
  const expiryTimeMilliSeconds = +(
    window.localStorage.getItem(`${key}ExpiryTime`) || 0
  )
  if (expiryTimeMilliSeconds && expiryTimeMilliSeconds > Date.now()) {
    return window.localStorage.getItem(key)
  }
  return null
}

export const setSortTermLocalStorage = (
  key: string,
  value: string,
  seconds = 3600,
) => {
  if (!canUseDOM()) return
  window.localStorage.setItem(key, value)
  const expiryTimeMilliSeconds = Date.now() + seconds * 1000
  window.localStorage.setItem(`${key}ExpiryTime`, `${expiryTimeMilliSeconds}`)
}
